import React, { useState } from 'react';
import ProgramsInfo from '../components/Programs/ProgramsInfo';
import Aside from '../modules/SideNav/Aside';

function ProgramsInfoLayout() {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = value => {
        setToggled(value);
    };

    return (
        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
            <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <ProgramsInfo handleToggleSidebar={handleToggleSidebar} />
        </div>
    );
}

export default ProgramsInfoLayout;
